import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const  merchantRouter: Array<RouteRecordRaw> = [
    {
        path: '/merchant',
        name: '商户管理',
        component: Layout,
        redirect: '',
        meta: { title: '商户管理', icon: 'icon-merchant', alwaysShow: true },
        children: [
            {
                path: 'logistics-company',
                name: '物流公司列表',
                component: () => import('@/views/merchant/LogisticsCompany.vue'),
                meta: { title: '物流公司列表' }
            },
            {
                path: 'rating-list',
                name: '商家评级列表',
                component: () => import('@/views/merchant/RatingList.vue'),
                meta: { title: '商家评级列表' }
            },
            {
                path: 'customer-complaint',
                name: '客诉详情',
                component: () => import('@/views/merchant/CustomerComplaint.vue'),
                meta: { title: '客诉详情' }
            },
            {
                path: 'shop-list',
                name: '工作人员门店管理',
                component: () => import('@/views/merchant/StaffShopList.vue'),
                meta: { title: '运营门店管理', keepAlive: true, depth: 30 }
            },
        ]
    }
]

export default  merchantRouter